import { i as e, r as t, s as n } from "./chunks/errors-BJxlOkXf.js";
import { normalizeApplicationCode as r, normalizeBasePath as i } from "./core.js";
import { n as a, r as o, t as s } from "./chunks/processInitiationViewContext-CRN1YTzW.js";
import { o as c } from "./chunks/formSessionValidation-CVWkHZ2j.js";
//#region src/auth/permissionContext.ts
function l(e, n, i) {
	let a = r(n);
	if (!e || typeof e.applicationCode != "string" || r(e.applicationCode) !== a || !u(e.permissionCodes) || !u(e.scopes) || i && (r(i.applicationCode) !== a || JSON.stringify([...new Set(i.scopes)].sort()) !== JSON.stringify([...new Set(e.scopes)].sort()))) throw new t("SDK_PERMISSION_CONTEXT_INVALID", "应用权限快照与目标访问票据不一致");
	return Object.freeze({
		applicationCode: a,
		permissionCodes: Object.freeze([...new Set(e.permissionCodes)]),
		scopes: Object.freeze([...new Set(i?.scopes ?? e.scopes)])
	});
}
function u(e) {
	return Array.isArray(e) && e.every((e) => typeof e == "string" && !!e.trim());
}
//#endregion
//#region src/auth/sessionClient.ts
var d = class {
	baseUrl;
	fetcher;
	constructor(e, t = globalThis.fetch.bind(globalThis)) {
		this.baseUrl = e, this.fetcher = t;
	}
	getSession(e) {
		return this.request("/api/auth/session", { signal: e }, f);
	}
	permissionContext(e, t) {
		return this.request(`/api/portal/applications/${encodeURIComponent(e)}/permission-context`, { signal: t }, (t) => l(t, e));
	}
	login(e, t, n) {
		return this.request("/api/auth/login", {
			method: "POST",
			signal: n,
			body: JSON.stringify({
				identifier: e,
				password: t
			}),
			headers: { "Content-Type": "application/json" }
		}, f);
	}
	async logout(e) {
		await this.request("/api/auth/session", {
			method: "DELETE",
			signal: e
		}, () => void 0);
	}
	accessToken(e, t) {
		return this.request("/api/auth/access-tokens", {
			method: "POST",
			signal: t,
			body: JSON.stringify({ applicationCode: e }),
			headers: { "Content-Type": "application/json" }
		}, p);
	}
	async request(e, r, i) {
		let a = await this.fetcher(`${this.baseUrl}${e}`, {
			credentials: "include",
			...r,
			headers: {
				Accept: "application/json",
				...r.headers
			}
		});
		if (!a.ok) {
			let e = await a.json().catch(() => ({}));
			throw n(a, e);
		}
		if (a.status === 204) return;
		let o = await a.json().catch((e) => {
			throw new t("SDK_RESPONSE_INVALID", "平台响应不是有效 JSON", {
				status: a.status,
				cause: e
			});
		});
		try {
			return i(o);
		} catch (e) {
			throw e instanceof t ? e : new t("SDK_RESPONSE_INVALID", "平台响应结构不合法", {
				status: a.status,
				cause: e
			});
		}
	}
};
function f(e) {
	let t = m(e);
	return Object.freeze({
		actorPublicId: h(t.actorPublicId),
		actorName: h(t.actorName),
		tenantPublicId: h(t.tenantPublicId),
		tenantName: h(t.tenantName),
		platformOperator: v(t.platformOperator),
		permissionCodes: Object.freeze(_(t.permissionCodes)),
		expiresAt: g(t.expiresAt)
	});
}
function p(e) {
	let t = m(e);
	return Object.freeze({
		accessToken: h(t.accessToken),
		expiresAt: g(t.expiresAt),
		applicationCode: h(t.applicationCode),
		scopes: Object.freeze(_(t.scopes))
	});
}
function m(e) {
	if (!e || typeof e != "object" || Array.isArray(e)) throw Error("response must be an object");
	return e;
}
function h(e) {
	if (typeof e != "string" || !e.trim()) throw Error("required string is missing");
	return e.trim();
}
function g(e) {
	let t = h(e);
	if (!Number.isFinite(Date.parse(t))) throw Error("invalid instant");
	return t;
}
function _(e) {
	if (!Array.isArray(e) || e.some((e) => typeof e != "string" || !e.trim())) throw Error("invalid string array");
	return [...new Set(e.map((e) => e.trim()))];
}
function v(e) {
	if (typeof e != "boolean") throw Error("invalid boolean");
	return e;
}
//#endregion
//#region src/auth/tokenManager.ts
var y = class {
	applicationCode;
	loader;
	refreshWindowMs;
	current;
	inflight;
	disposed = !1;
	generation = 0;
	listeners = /* @__PURE__ */ new Set();
	constructor(e, t, n, r = 3e4) {
		this.applicationCode = e, this.loader = t, this.refreshWindowMs = r, this.current = n ? this.normalize(n) : void 0;
	}
	peek() {
		return this.current;
	}
	subscribe(e) {
		return this.assertActive(), this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	async get(e = !1, t) {
		if (this.assertActive(), t?.aborted) throw t.reason ?? new DOMException("Aborted", "AbortError");
		if (!e && this.current && this.isFresh(this.current)) return this.current;
		this.inflight || this.startRefresh();
		let n = this.inflight;
		if (!n) throw x();
		return b(n.promise, t);
	}
	replace(e) {
		this.assertActive(), this.generation += 1, this.invalidateInflight(), this.current = this.normalize(e), this.notify();
	}
	clear() {
		this.generation += 1, this.current = void 0, this.invalidateInflight(), this.notify();
	}
	dispose() {
		this.disposed || (this.disposed = !0, this.clear(), this.listeners.clear());
	}
	startRefresh() {
		let e = this.generation, n = new AbortController(), r = this.loader(n.signal).then((e) => this.normalize(e)).then((n) => {
			if (this.disposed || e !== this.generation) throw new t("SDK_TOKEN_REFRESH_INVALIDATED", "Access Token 刷新结果已失效");
			return this.current = n, this.notify(), n;
		}).finally(() => {
			this.inflight?.promise === r && (this.inflight = void 0);
		});
		r.catch(() => void 0), this.inflight = {
			promise: r,
			controller: n,
			generation: e
		};
	}
	isFresh(e) {
		let t = Date.parse(e.expiresAt);
		return Number.isFinite(t) && t - Date.now() > this.refreshWindowMs;
	}
	notify() {
		this.listeners.forEach((e) => e(this.current));
	}
	normalize(e) {
		if (!e || typeof e != "object") throw x();
		if (e.applicationCode.trim().toUpperCase() !== this.applicationCode) throw new t("SDK_TOKEN_AUDIENCE_MISMATCH", "Access Token audience 不匹配");
		if (!e.accessToken?.trim() || !Number.isFinite(Date.parse(e.expiresAt)) || !Array.isArray(e.scopes) || e.scopes.some((e) => typeof e != "string" || !e.trim())) throw x();
		return Object.freeze({
			...e,
			accessToken: e.accessToken.trim(),
			applicationCode: this.applicationCode,
			scopes: Object.freeze([...new Set(e.scopes.map((e) => e.trim()))])
		});
	}
	invalidateInflight() {
		let e = this.inflight;
		this.inflight = void 0, e?.controller.abort(new DOMException("Token refresh invalidated", "AbortError"));
	}
	assertActive() {
		if (this.disposed) throw new t("SDK_RUNTIME_DISPOSED", "运行时已卸载");
	}
};
function b(e, t) {
	return t ? t.aborted ? Promise.reject(t.reason ?? new DOMException("Aborted", "AbortError")) : new Promise((n, r) => {
		let i = () => r(t.reason ?? new DOMException("Aborted", "AbortError"));
		t.addEventListener("abort", i, { once: !0 }), e.then((e) => {
			t.removeEventListener("abort", i), n(e);
		}, (e) => {
			t.removeEventListener("abort", i), r(e);
		});
	}) : e;
}
function x() {
	return new t("SDK_TOKEN_INVALID", "Access Token 响应不完整");
}
//#endregion
//#region src/auth/httpClient.ts
var S = class {
	options;
	baseUrl;
	fetcher;
	notifiedAccessTokens = /* @__PURE__ */ new WeakSet();
	constructor(e) {
		if (this.options = e, this.baseUrl = (e.apiBaseUrl ?? "").replace(/\/+$/, ""), this.fetcher = e.fetch ?? globalThis.fetch.bind(globalThis), !e.businessApiMatchers.length) throw Error("businessApiMatchers 不能为空");
	}
	async request(e, t = {}) {
		let n = C(t);
		return this.execute(e, n, !1);
	}
	get(e, t = {}) {
		return this.request(e, {
			...t,
			method: "GET"
		});
	}
	post(e, t, n = {}) {
		return this.request(e, {
			...n,
			method: "POST",
			body: t
		});
	}
	async execute(e, r, i) {
		if (r.signal?.aborted) throw r.signal.reason ?? new DOMException("Aborted", "AbortError");
		let a = new URL(e, this.baseUrl || globalThis.location?.origin || "http://sdk.invalid"), o = this.options.businessApiMatchers.some((e) => T(e, a)) && !a.pathname.startsWith("/api/auth/"), s = new Headers(r.headers);
		s.set("Accept", "application/json");
		let c;
		o && (c = await this.options.tokenManager.get(!1, r.signal ?? void 0), s.set("Authorization", `Bearer ${c.accessToken}`));
		let l = r.bodyFactory?.();
		l != null && typeof l == "string" && !s.has("Content-Type") && s.set("Content-Type", "application/json");
		let u = await this.fetcher(`${this.baseUrl}${a.pathname}${a.search}`, {
			...r.init,
			headers: s,
			body: l,
			signal: r.signal,
			credentials: r.credentials ?? "include"
		});
		if (!u.ok) {
			let t = await u.clone().json().catch(() => ({}));
			if (!i && o && u.status === 401 && t.code === "100900018" && r.retryable && r.bodyFactory && !r.signal?.aborted) return await this.options.tokenManager.get(!0, r.signal ?? void 0), this.execute(e, r, !0);
			let a = n(u, t);
			if (i && o && u.status === 401 && t.code === "100900018" && c !== void 0 && !this.notifiedAccessTokens.has(c)) {
				this.notifiedAccessTokens.add(c);
				try {
					this.options.onSessionExpired?.(a);
				} catch {}
			}
			throw a;
		}
		if (u.status !== 204) try {
			return await u.json();
		} catch (e) {
			throw new t("SDK_RESPONSE_INVALID", "平台响应不是有效 JSON", {
				status: u.status,
				cause: e
			});
		}
	}
};
function C(e) {
	let { body: t, bodyFactory: n, retryable: r = !0, headers: i, signal: a, credentials: o, ...s } = e;
	if (n && t !== void 0) throw Error("body 与 bodyFactory 不能同时声明");
	let c = n ?? w(t);
	return {
		init: s,
		headers: i,
		bodyFactory: c,
		retryable: r && c !== void 0,
		signal: a,
		credentials: o
	};
}
function w(e) {
	if (e == null) return () => null;
	if (typeof e == "string" || e instanceof URLSearchParams || e instanceof Blob) return () => e;
	if (e instanceof FormData) {
		let t = [...e.entries()];
		return () => {
			let e = new FormData();
			return t.forEach(([t, n]) => e.append(t, n)), e;
		};
	}
	if (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) {
		let t = e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
		return () => t.slice();
	}
	if (!(e instanceof ReadableStream)) {
		if (typeof e == "object") {
			let t = JSON.stringify(e);
			return () => t;
		}
		throw new t("SDK_REQUEST_BODY_UNSUPPORTED", "请求 Body 无法安全重建");
	}
}
function T(e, t) {
	return typeof e == "string" ? t.pathname.startsWith(e) : e instanceof RegExp ? (e.lastIndex = 0, e.test(t.pathname)) : e(t);
}
//#endregion
//#region src/auth/runtime.ts
var E = class {
	options;
	applicationCode;
	sessionClient;
	tokenManager;
	http;
	contextValue;
	disposed = !1;
	generation = 0;
	embedded;
	permissionSnapshot;
	pendingPermissions = /* @__PURE__ */ new Map();
	listeners = /* @__PURE__ */ new Set();
	constructor(e) {
		this.options = e, this.applicationCode = r(e.applicationCode);
		let t = e.window ?? globalThis.window;
		this.embedded = O(e.embeddedProps ?? t?.$wujie?.props, this.applicationCode, e.trustedEmbeddedOrigins ?? [], t);
		let n = (this.embedded?.apiBaseUrl ?? e.apiBaseUrl ?? "").replace(/\/+$/, "");
		this.sessionClient = new d(n, e.fetch);
		let i = this.embedded?.accessToken;
		this.tokenManager = new y(this.applicationCode, async (e) => {
			let t = await (this.embedded ? this.embedded.refreshAccessToken() : this.sessionClient.accessToken(this.applicationCode, e)), n = l(await this.sessionClient.permissionContext(this.applicationCode, e), this.applicationCode, t);
			if (e?.aborted || this.disposed) throw e?.reason ?? new DOMException("Runtime invalidated", "AbortError");
			return this.pendingPermissions.set(t.accessToken, n), t;
		}, i), this.tokenManager.subscribe((e) => {
			this.permissionSnapshot = e ? this.pendingPermissions.get(e.accessToken) ?? l({
				applicationCode: this.applicationCode,
				permissionCodes: [],
				scopes: e.scopes
			}, this.applicationCode, e) : l({
				applicationCode: this.applicationCode,
				permissionCodes: [],
				scopes: []
			}, this.applicationCode), this.pendingPermissions.clear(), this.listeners.forEach((e) => e());
		}), this.http = new S({
			apiBaseUrl: n,
			businessApiMatchers: e.businessApiMatchers,
			tokenManager: this.tokenManager,
			fetch: e.fetch,
			onSessionExpired: (e) => this.embedded?.onSessionExpired?.()
		});
	}
	async initialize(e) {
		if (this.assertActive(), this.contextValue) return {
			status: "ready",
			context: this.contextValue
		};
		if (this.embedded) return this.permissionSnapshot = l({
			applicationCode: this.applicationCode,
			permissionCodes: this.embedded.permissionCodes,
			scopes: this.embedded.accessToken.scopes
		}, this.applicationCode, this.tokenManager.peek()), this.contextValue = this.freezeContext({
			...this.embedded,
			mode: "embedded",
			applicationCode: this.applicationCode,
			accessTokenScopes: this.embedded.accessToken.scopes,
			basePath: i(this.embedded.basePath),
			operationHost: M(this.embedded),
			workflowPageHost: N(this.embedded, this.applicationCode),
			processInitiationViewHost: P(this.embedded, this.applicationCode),
			formSessionHost: this.embedded.runtimePurpose === "form-session" ? c(this.embedded.formSessionHost) : void 0
		}), {
			status: "ready",
			context: this.contextValue
		};
		try {
			let t = this.generation, n = await this.sessionClient.getSession(e);
			this.assertGeneration(t, e);
			let r = await this.tokenManager.get(!1, e);
			return this.assertGeneration(t, e), this.contextValue = this.freezeContext({
				...n,
				permissionCodes: this.permissionSnapshot?.permissionCodes ?? [],
				mode: "standalone",
				applicationCode: this.applicationCode,
				apiBaseUrl: (this.options.apiBaseUrl ?? "").replace(/\/+$/, ""),
				basePath: i(this.options.basePath ?? "/"),
				accessTokenScopes: r.scopes
			}), {
				status: "ready",
				context: this.contextValue
			};
		} catch (e) {
			return e instanceof t && e.status === 401 ? {
				status: "auth-required",
				mode: "standalone"
			} : {
				status: "unavailable",
				mode: "standalone",
				error: e
			};
		}
	}
	context() {
		if (this.assertActive(), !this.contextValue) throw new t("SDK_RUNTIME_NOT_READY", "请先初始化 PlatformRuntime");
		return this.contextValue;
	}
	subscribe(e) {
		return this.assertActive(), this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	permissions() {
		if (this.assertActive(), !this.permissionSnapshot) throw new t("SDK_RUNTIME_NOT_READY", "应用权限快照尚未就绪");
		return this.permissionSnapshot;
	}
	freezeContext(e) {
		let t = this;
		return Object.freeze({
			...e,
			get permissionCodes() {
				return t.permissionSnapshot?.permissionCodes ?? A;
			},
			get accessTokenScopes() {
				return t.permissionSnapshot?.scopes ?? A;
			},
			subscribe: (e) => t.subscribe(e)
		});
	}
	async login(e, n, r) {
		if (this.assertActive(), this.embedded) throw new t("SDK_LOGIN_EMBEDDED_FORBIDDEN", "嵌入态登录由 Portal 管理");
		return this.generation += 1, await this.sessionClient.login(e, n, r), this.contextValue = void 0, this.tokenManager.clear(), this.initialize(r);
	}
	async logout(e) {
		this.assertActive(), this.generation += 1, this.embedded || await this.sessionClient.logout(e), this.tokenManager.clear(), this.contextValue = void 0, this.embedded?.onSessionExpired();
	}
	dispose() {
		this.disposed || (this.disposed = !0, this.generation += 1, this.tokenManager.dispose(), this.contextValue = void 0, this.pendingPermissions.clear(), this.listeners.clear());
	}
	assertActive() {
		if (this.disposed) throw new t("SDK_RUNTIME_DISPOSED", "运行时已卸载");
	}
	assertGeneration(e, t) {
		if (this.assertActive(), e !== this.generation || t?.aborted) throw t?.reason ?? new DOMException("Runtime initialization invalidated", "AbortError");
	}
};
function D(e) {
	return new E(e);
}
function O(n, i, a, o) {
	if (n == null) return;
	let s = new Set(a.map((e) => new URL(e).origin));
	o?.location?.origin && s.add(o.location.origin);
	let l = o?.document?.referrer;
	if (l && !s.has(new URL(l).origin)) throw new t("SDK_EMBEDDED_ORIGIN_UNTRUSTED", "Portal 来源不受信任");
	if (!n || typeof n != "object") throw k();
	let u = n;
	if ([
		"runtimeMode",
		"applicationCode",
		"apiBaseUrl",
		"basePath",
		"actorPublicId",
		"actorName",
		"tenantPublicId",
		"tenantName"
	].some((e) => typeof u[e] != "string" || !String(u[e]).trim()) || u.runtimeMode !== "embedded" || r(String(u.applicationCode)) !== i || typeof u.platformOperator != "boolean" || !Array.isArray(u.permissionCodes) || u.permissionCodes.some((e) => typeof e != "string") || !u.accessToken || typeof u.accessToken != "object" || [
		"refreshAccessToken",
		"navigate",
		"registerPrimaryNavigation",
		"onPrimaryNavigationChange",
		"onSessionExpired"
	].some((e) => typeof u[e] != "function")) throw k();
	if (u.runtimePurpose !== void 0 && ![
		"navigation",
		"transient",
		"form-session"
	].includes(String(u.runtimePurpose))) throw e("CAPABILITY_INVALID");
	if (u.runtimePurpose === "form-session") {
		if (c(u.formSessionHost), [
			"operationPageRoute",
			"reportOperationRouteReady",
			"reportOperationRouteFailed",
			"registerOperationPageBridge",
			"operationInvocationId",
			"reportOperationCompleted",
			"requestOperationClose",
			"workflowPageRoute",
			"workflowPageContext",
			"reportWorkflowPageReady",
			"reportWorkflowPageFailed",
			"registerWorkflowPageBridge",
			"processInitiationViewPageRoute",
			"processInitiationViewContext",
			"reportProcessInitiationViewReady",
			"reportProcessInitiationViewFailed"
		].some((e) => u[e] !== void 0)) throw e("CAPABILITY_INVALID");
	} else if (u.formSessionHost !== void 0) throw e("CAPABILITY_INVALID");
	return u;
}
function k() {
	return new t("SDK_EMBEDDED_CONTEXT_INVALID", "Wujie 运行时上下文不完整或不匹配");
}
var A = Object.freeze([]);
function j(e) {
	return e.accessToken;
}
function M(e) {
	if (![
		e.operationPageRoute,
		e.reportOperationRouteReady,
		e.reportOperationRouteFailed,
		e.registerOperationPageBridge,
		e.operationInvocationId,
		e.reportOperationCompleted,
		e.requestOperationClose
	].every((e) => e === void 0)) {
		if (typeof e.operationPageRoute != "string" || !e.operationPageRoute.startsWith("/") || e.operationPageRoute.includes("..") || typeof e.reportOperationRouteReady != "function" || e.reportOperationRouteFailed !== void 0 && typeof e.reportOperationRouteFailed != "function" || typeof e.registerOperationPageBridge != "function" || [
			e.operationInvocationId,
			e.reportOperationCompleted,
			e.requestOperationClose
		].some((e) => e !== void 0) && (typeof e.operationInvocationId != "string" || !/^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/.test(e.operationInvocationId) || typeof e.reportOperationCompleted != "function" || typeof e.requestOperationClose != "function")) throw k();
		return Object.freeze({
			pageRoute: e.operationPageRoute,
			reportRouteReady: e.reportOperationRouteReady,
			reportRouteFailed: e.reportOperationRouteFailed,
			registerBridge: e.registerOperationPageBridge,
			operationInvocationId: e.operationInvocationId,
			reportCompleted: e.reportOperationCompleted,
			requestClose: e.requestOperationClose
		});
	}
}
function N(e, n) {
	if ([
		e.workflowPageRoute,
		e.workflowPageContext,
		e.reportWorkflowPageReady,
		e.reportWorkflowPageFailed,
		e.registerWorkflowPageBridge
	].every((e) => e === void 0)) return;
	if (typeof e.workflowPageRoute != "string" || !a(e.workflowPageRoute) || typeof e.reportWorkflowPageReady != "function" || typeof e.reportWorkflowPageFailed != "function" || typeof e.registerWorkflowPageBridge != "function") throw new t("SDK_WORKFLOW_CAPABILITY_INVALID", "Workflow 工作项页面能力组合不完整或非法");
	let r = o(e.workflowPageContext, n);
	return Object.freeze({
		pageRoute: e.workflowPageRoute,
		context: r,
		reportReady: e.reportWorkflowPageReady,
		reportFailed: e.reportWorkflowPageFailed,
		registerBridge: e.registerWorkflowPageBridge
	});
}
function P(e, n) {
	let r = [
		e.processInitiationViewPageRoute,
		e.processInitiationViewContext,
		e.reportProcessInitiationViewReady,
		e.reportProcessInitiationViewFailed
	];
	if (!r.every((e) => e === void 0)) {
		if (typeof e.processInitiationViewPageRoute != "string" || !a(e.processInitiationViewPageRoute) || typeof e.reportProcessInitiationViewReady != "function" || typeof e.reportProcessInitiationViewFailed != "function" || r.some((e) => e === void 0) || e.workflowPageContext !== void 0 || e.workflowPageRoute !== void 0) throw new t("SDK_WORKFLOW_CAPABILITY_INVALID", "发起实例只读页面宿主能力组合不完整或非法");
		return Object.freeze({
			pageRoute: e.processInitiationViewPageRoute,
			context: s(e.processInitiationViewContext, n),
			reportReady: e.reportProcessInitiationViewReady,
			reportFailed: e.reportProcessInitiationViewFailed
		});
	}
}
//#endregion
export { y as AccessTokenManager, S as PlatformHttpClient, E as PlatformRuntime, d as PlatformSessionClient, j as createEmbeddedAccessToken, D as createPlatformRuntime, l as validatePermissionContext };
